import { useQuery } from 'react-query'
import { doGroupPay } from '../../../services/easyPay'

export default function useSetDoGroupPay(payload: any) {
    const { isLoading, data, refetch } = useQuery([payload], doGroupPay)
    return { isLoading, data, refetch }
}
